import { PDF_FONT_FAMILY, PDF_FONT_SIZE } from '../components/reports/shared/constants';

/** ExcelJS: `font.size` is in points */
export const TIME_TRACKER_EXPORT_FONT_NAME = PDF_FONT_FAMILY;
export const TIME_TRACKER_EXPORT_EXCEL_FONT_SIZE_PT = PDF_FONT_SIZE.VALUE;

/**
 * docx `TextRun` / table `run.size`: half-points (8 pt → 16).
 * @see https://docx.js.org/api/classes/TextRun.html
 */
export const TIME_TRACKER_EXPORT_DOCX_TEXT_RUN_HALF_POINTS = PDF_FONT_SIZE.VALUE * 2;

export function getTimeTrackerExcelFonts() {
  const name = TIME_TRACKER_EXPORT_FONT_NAME;
  const size = TIME_TRACKER_EXPORT_EXCEL_FONT_SIZE_PT;
  return {
    defaultFont: { name, size },
    boldFont: { name, size, bold: true },
  };
}

/** docx `Document` styles.default.document.run */
export function getTimeTrackerDocxDocumentRunDefaults() {
  return {
    font: TIME_TRACKER_EXPORT_FONT_NAME,
    size: TIME_TRACKER_EXPORT_DOCX_TEXT_RUN_HALF_POINTS,
  };
}
